(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[239],{

/***/ 80239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero029": function() { return /* binding */ Hero029; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52853);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32667);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87367);
/* harmony import */ var _Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32588);
/* harmony import */ var _Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9__);










var Hero029 = function(param) {
    var payload = param.payload;
    var ref;
    var headline = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var points = (ref2 = payload === null || payload === void 0 ? void 0 : payload.points) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    var image = (ref3 = payload === null || payload === void 0 ? void 0 : payload.image) !== null && ref3 !== void 0 ? ref3 : {};
    var ref4;
    var ref5 = (ref4 = payload === null || payload === void 0 ? void 0 : payload.request) !== null && ref4 !== void 0 ? ref4 : {}, buttonText = ref5.buttonText, form = ref5.form, type = ref5.type, link = ref5.link;
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_3__/* .buildWidgetInstanceId */ .G1)("029", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__/* .WIDGETS_REGISTRY.HERO */ .R.HERO);
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().query;
    var ref6 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useToggle */ .OT)(), opened = ref6.opened, onOpen = ref6.onOpen, onClose = ref6.onClose;
    var baseUrl =  true ? window.location.origin : 0;
    var externalLink = (link === null || link === void 0 ? void 0 : link.startsWith("http")) || (link === null || link === void 0 ? void 0 : link.startsWith("https")) ? link : "".concat(baseUrl).concat(link);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading2 */ .XJ, {
                            className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().headline),
                            color: "dark",
                            children: headline
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .RenderIf */ .$b, {
                            viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_7__/* .VIEW_MODES.MOBILE */ .nY.MOBILE,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                value: description,
                                className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().description)
                            })
                        }),
                        type === "external link" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: externalLink,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().play),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrow),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                        className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
                                        name: "arrow_right"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                    color: "brand",
                                    children: buttonText
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Action */ .aU, {
                            onClick: onOpen,
                            className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().play),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrow),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                        className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
                                        name: "arrow_right"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                    color: "brand",
                                    children: buttonText
                                })
                            ]
                        }),
                        opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ModalWrapper */ .AB, {
                            onCloseModal: onClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                item: form,
                                metaData: {
                                    page: query.slug
                                },
                                instanceId: instanceId,
                                onReset: onClose
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .RenderIf */ .$b, {
                    viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_7__/* .VIEW_MODES.DESKTOP */ .nY.DESKTOP,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                        value: description,
                        className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().description)
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .OrderedList */ .GS, {
                    items: points,
                    className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().points)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageLite */ .NH, {
                    image: image,
                    className: (_Hero029_module_scss__WEBPACK_IMPORTED_MODULE_9___default().image)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero029);


/***/ }),

/***/ 32588:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero029_wrapper__servK","content":"Hero029_content__iz7hC","headline":"Hero029_headline__QyaPA","description":"Hero029_description__nGqqx","image":"Hero029_image___DJeH","play":"Hero029_play__lsrTk","icon":"Hero029_icon__AXAnO","arrow":"Hero029_arrow__lY1R5","points":"Hero029_points__S8_2X"};

/***/ })

}]);